import LokaliseMarkdownText from "@whoppah/components/text/LokaliseMarkdownText";
import SEO from "../common/seo";
import { useTranslation } from "next-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("privacy-policy:privacy-policy-title")} />
      <LokaliseMarkdownText
        lokaliseKey="privacy-policy:privacy-policy-content"
        className="flex flex-col gap-4 p-[8px] md:p-[64px]"
      />
    </>
  );
};

export default PrivacyPolicy;
